import type { ChannelRow } from "../../schema/datalogger.schema";

/** One-line summary for threshold pills and compact UI. */
export function formatChannelThresholdSummary(row: ChannelRow): string | null {
  const numericLike =
    row.dataType === "float" || row.dataType === "int" || row.dataType === "formula";
  if (numericLike) {
    const parts: string[] = [];
    if (row.minValue != null) parts.push(`Min ${row.minValue}`);
    if (row.maxValue != null) parts.push(`Max ${row.maxValue}`);
    if (row.thresholdWarningLow != null) parts.push(`Warn lo ${row.thresholdWarningLow}`);
    if (row.thresholdWarningHigh != null) parts.push(`Warn hi ${row.thresholdWarningHigh}`);
    return parts.length > 0 ? parts.join(" · ") : null;
  }
  if (row.dataType === "bool") {
    if (row.boolExpected !== "any") {
      return `Expect: ${row.boolExpected}`;
    }
    return null;
  }
  if (row.stringMaxLength != null) {
    return `Max length ${row.stringMaxLength}`;
  }
  return null;
}
